import { Grid, Typography } from '@mui/material';
import { NumberField, SimpleShowLayout, useGetOne, useRecordContext } from 'react-admin';
import { DataProviderResource } from 'src/constants';
import { FinancialAssets } from 'src/lib';
import { Account, AccountBalance } from 'src/models';

import { AccountTransferList } from '../Accounts/Summary/AccountTransferList';
import { AccountNontradablePositionList } from '../Orders/AccountNontradablePositionList';
import { AccountTradablePositionsList } from '../Orders/AccountTradablePositionsList';

export const OfferOrderAccountSummaryTab = () => {
  const record = useRecordContext();

  const { data: accountBalance } = useGetOne<AccountBalance>('balances', { id: record.accountId });
  const { data: account } = useGetOne<Account>(DataProviderResource.Accounts, { id: record.account.id });

  return (
    <Grid container direction='row'>
      <Grid container direction='row'>
        <Grid item xs={12}>
          <SimpleShowLayout>
            <Typography variant='h5'>Account Balance</Typography>
          </SimpleShowLayout>
        </Grid>
        <Grid item xs={6} sm={4}>
          <SimpleShowLayout>
            <NumberField
              label='Cash Balance'
              source='cashBalance'
              record={accountBalance}
              fullWidth
              options={{ style: 'currency', currency: 'USD' }}
            />
          </SimpleShowLayout>
        </Grid>
        <Grid item xs={6} sm={4}>
          <SimpleShowLayout>
            <NumberField
              label='Cash Available'
              source='cashAvailable'
              record={accountBalance}
              fullWidth
              options={{ style: 'currency', currency: 'USD' }}
            />
          </SimpleShowLayout>
        </Grid>
        <Grid item xs={6} sm={4}>
          <SimpleShowLayout>
            <NumberField
              label='Funds available for withdrawal'
              source='cashAvailableForWithdrawal'
              record={accountBalance}
              fullWidth
              options={{ style: 'currency', currency: 'USD' }}
            />
          </SimpleShowLayout>
        </Grid>
      </Grid>
      {account?.primaryAccountHolder && <FinancialAssets record={account} />}
      <Grid item xs={12}>
        <SimpleShowLayout>
          <Typography variant='h5'>Money Transactions</Typography>
        </SimpleShowLayout>
        <AccountTransferList accountId={record.accountId} accountNumber={account?.accountNumber} />
      </Grid>
      <Grid item xs={12}>
        <SimpleShowLayout>
          <Typography variant='h5'>Security Holdings</Typography>
        </SimpleShowLayout>
        <AccountTradablePositionsList accountId={record.accountId} />
      </Grid>
      <Grid item xs={12}>
        <SimpleShowLayout>
          <Typography variant='h5'>Non-Traded Holdings</Typography>
        </SimpleShowLayout>
        <AccountNontradablePositionList accountId={record.accountId} />
      </Grid>
    </Grid>
  );
};
